<div class="upload-item position-relative" [class.d-flex]="preview">
	<!-- <div *ngIf="preview && documentType?.url">
  <img class="img-fluid" height="90" width="90" [alt]="documentType?.label" [src]="documentType?.url" loading="lazy" />
</div> -->

	<div class="d-block w-100 button-container" [ngClass]="{ 'ms-1': preview, responsive: responsive }">
		<span>{{ documentType?.label }}</span>

		@if (!acceptAllFiles) {
			<label [for]="fieldId" [ngClass]="{ 'larger-label': !preview && !documentType?.url }">
				{{ clientType === 'PJ' ? uploadComponentString.fileFormatOfUpPJ : uploadComponentString.fileFormatOfUp }}
			</label>
		}

		@if (acceptAllFiles) {
			<label [for]="fieldId" [ngClass]="{ 'larger-label': !preview && !documentType?.url }">
				{{ clientType === 'PJ' ? 'Documento en formato PDF/JPG/JPEG/PNG hasta 10mb' : uploadComponentString.fileFormatOfUp }}
			</label>
		}

		<input #files type="file" [name]="fieldId" [id]="fieldId" class="upload-input" (change)="compressDocument(documentType?.type, files)" />

		<div class="snapshot-button-container d-inline-flex">
			<button type="button" (click)="showSnapshotModal = true">
				<img src="/assets/icons/svg/camera-icon.svg" alt="Ícone de máquina fotográfica" loading="lazy" />
			</button>
		</div>

		@if (documentType?.type === 2 && isMobile) {
			<span class="warning-message">
				{{ uploadComponentString.removeTheDocumentPlasticAndMakeAllDataLegible }}
			</span>
		}

		@if (documentType?.type === 1 && isMobile) {
			<span class="warning-message">
				{{ uploadComponentString.makeSureTheImageClearDoNotWearGlassesHatsAccessories }}
			</span>
		}

		<button type="button" [disabled]="isPending" (click)="files.click()" [id]="documentType?.type" class="btn btn-secondary d-inline-flex align-items-center justify-content-center generic-button">
			@if (isPending) {
				<span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
			}
			{{ isPending ? uploadComponentString.sending : uploadComponentString.toSend }}
		</button>

		<div class="file-validation d-inline-flex">
			@if (success !== undefined && success) {
				<div class="validation-container d-inline-flex">
					<img class="mr-2" src="/assets/icons/svg/aviso-positivo.svg" alt="" loading="lazy" />
					<span (click)="openPreviewModal()" [style.cursor]="previewUrl ? 'pointer' : 'default'" [style.text-decoration]="previewUrl ? 'underline' : 'none'">
						{{ fileName }}
					</span>
				</div>
			}
			@if (success !== undefined && !success) {
				<div class="validation-container d-inline-flex">
					<img src="/assets/icons/svg/aviso-negativo.svg" alt="" loading="lazy" />
					<span>
						<strong>{{ uploadComponentString.unsupportedFile }}</strong>
						{{ uploadComponentString.checkTheSpecsAndSendAgain }}
					</span>
				</div>
			}
		</div>

		@if (documentType?.type === 2 && !isMobile) {
			<span class="warning-message">
				{{ uploadComponentString.removeDocumentPlasticAndMakeAllDataLegible }}
			</span>
		}

		@if (documentType?.type === 1 && !isMobile) {
			<span class="warning-message">
				{{ uploadComponentString.makeImageClearGlassesHatsAccessories }}
			</span>
		}
	</div>
</div>

@if (showSnapshotModal) {
	<div class="rod-modal-content">
		<div class="rod-modal">
			<div class="close-button" (click)="closeModal()">
				<img src="/assets/icons/svg/close-modal.svg" alt="Fechar modal" loading="lazy" />
			</div>
			<div class="content snapshot-modal">
				<div class="inner-snapshot-section">
					<webcam class="webcam-element" [width]="webcamWidth" [height]="webcamHeight" [trigger]="triggerObservable" (imageCapture)="handleImage(documentType?.type, $event)"> </webcam>
					<button type="button" (click)="triggerSnapshot()">
						@if (isPending) {
							<span class="spinner-border spinner-border-sm mb-0" role="status" aria-hidden="true"></span>
						}
						<span>{{ isPending ? uploadComponentString.sending : uploadComponentString.takeAPicture }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
}

<!-- Modal de vista previa -->
@if (showPreviewModal) {
	<div class="rod-modal-content" style="z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px; box-sizing: border-box">
		<div class="rod-modal preview-modal" style="position: relative; width: 90vw; max-width: 1200px; max-height: 90vh; margin: auto; border-radius: 12px; background: white; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3); display: flex; flex-direction: column">
			<div class="close-button" (click)="closePreviewModal()" style="position: absolute; z-index: 10000; top: 15px; right: 15px; cursor: pointer">
				<img src="/assets/icons/svg/close-modal.svg" alt="Cerrar modal" loading="lazy" />
			</div>
			<!-- Título fijo -->
			<div style="padding: 20px 50px 10px 20px; flex-shrink: 0">
				<h3 style="text-align: center; margin: 0; font-size: clamp(0.9rem, 2vw, 1.2rem); word-break: break-word">{{ fileName || uploadedFile?.name }}</h3>
			</div>
			<!-- Contenedor con scroll para la imagen/PDF -->
			<div style="flex: 1; overflow: auto; display: flex; min-height: 0">
				<!-- Vista previa de imagen -->
				@if (uploadedFile?.type?.startsWith('image/')) {
					<div style="width: 100%; padding: 10px 20px 20px 20px; display: flex; justify-content: center; align-items: flex-start">
						<img [src]="previewUrl" [alt]="fileName || uploadedFile?.name" style="max-width: 100%; height: auto; object-fit: contain; display: block; border-radius: 4px" />
					</div>
				}
				<!-- Vista previa de PDF -->
				@if (uploadedFile?.type === 'application/pdf' || (fileName && fileName.toLowerCase().endsWith('.pdf'))) {
					<div style="width: 100%; padding: 10px 20px 20px 20px">
						<iframe [src]="sanitizedPreviewUrl" type="application/pdf" style="width: 100%; height: 100%; min-height: 500px; border-radius: 4px; border: none"></iframe>
					</div>
				}
			</div>
		</div>
	</div>
}

<!-- Estilos responsivos para el modal -->
<style>
	.rod-modal-content {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
	}

	@media (max-width: 768px) {
		.preview-modal {
			width: 95vw !important;
			max-height: 95vh !important;
		}
		.preview-modal > div:first-of-type {
			padding: 15px 40px 10px 15px !important;
		}
		.preview-modal h3 {
			font-size: 0.85rem !important;
		}
		.preview-modal > div:last-of-type > div {
			padding: 10px 15px 15px 15px !important;
		}
		.preview-modal embed {
			min-height: 400px !important;
		}
		.preview-modal iframe {
			min-height: 400px !important;
		}
	}

	@media (max-width: 480px) {
		.preview-modal {
			width: 98vw !important;
			max-height: 98vh !important;
		}
		.preview-modal > div:first-of-type {
			padding: 12px 35px 8px 12px !important;
		}
		.preview-modal h3 {
			font-size: 0.75rem !important;
		}
		.preview-modal > div:last-of-type > div {
			padding: 8px 12px 12px 12px !important;
		}
		.preview-modal embed {
			min-height: 300px !important;
		}
		.preview-modal iframe {
			min-height: 300px !important;
		}
		.rod-modal-content {
			padding: 10px !important;
		}
	}
</style>
